module.exports = __webpack_public_path__ + "img/i.abc4c4bf.jpg";